/** Parse balance_aud from API / Pusher payloads (number or numeric string). */
export const parseBalanceAud = (value) => {
  if (value == null || value === "") {
    return null;
  }
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
};

export const buildWalletFromTopUp = (prevWallet, balanceAud, extras = {}) => ({
  ...(prevWallet || {}),
  ...extras,
  balance_aud: balanceAud,
  has_wallet: true,
  status: prevWallet?.status || extras.status || "active",
});

/** Apply a known post-top-up balance without clearing existing wallet fields. */
export const applyWalletBalance = (prevWallet, balanceAud) =>
  buildWalletFromTopUp(prevWallet, balanceAud);
